var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[(!_vm.isKey)?_c('canvas',{attrs:{"id":_vm.IdName,"width":_vm.contentWidth,"height":_vm.contentHeight},on:{"click":function($event){return _vm.changenum()}}}):_vm._e(),(_vm.isKey)?_c('img',{attrs:{"src":_vm.imgSrc,"alt":""},on:{"click":function($event){return _vm.changenum()}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }